var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"my-tr2-box",class:{'my-tr2-box-body':_vm.trType == 'body','my-tr2-box-title':_vm.trType == 'title'}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }